import { MapPin, ExternalLink } from 'lucide-react';

interface LandmarkCardProps {
  data: {
    name?: string;
    description?: string;
    address?: string;
    lat?: number;
    lng?: number;
    apple_maps_url?: string;
    icon?: string;
    color?: string;
  };
}

export default function LandmarkCard({ data }: LandmarkCardProps) {
  const color = data.color || '#a855f7';
  const mapsUrl = data.apple_maps_url
    || (data.lat && data.lng ? `https://maps.apple.com/?ll=${data.lat},${data.lng}&q=${encodeURIComponent(data.name || '')}` : null);

  return (
    <div
      className="my-2 border bg-[#0a1628]/80 backdrop-blur-sm p-3 max-w-[300px]"
      style={{
        borderColor: `${color}50`,
        clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))',
      }}
    >
      <div className="flex items-center gap-2 mb-1">
        <MapPin className="w-4 h-4" style={{ color }} />
        <span className="font-semibold text-sm" style={{ color }}>{data.name || 'Landmark'}</span>
      </div>

      {data.description && (
        <div className="text-gray-400 text-xs mb-1">{data.description}</div>
      )}

      {data.address && (
        <div className="text-gray-300 text-xs font-mono mb-2">{data.address}</div>
      )}

      {mapsUrl && (
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 text-xs hover:opacity-80 transition-opacity"
          style={{ color }}
        >
          <ExternalLink className="w-3 h-3" />
          Open in ATLAS
        </a>
      )}
    </div>
  );
}
